module.exports = __webpack_public_path__ + "static/media/f9.40b54b00.png";